import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import AccessFilterSelector from './AccessFilterSelector'

const ownerFilter = (source: ReturnType<typeof usePerformanceReviewsDataTable>) =>
  buildPerformanceReviewsDataTableFilter(source, {
    title: i18n.t('performance_process.reviews.datatable.owned_by'),
    path: 'ownerIds',
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        component: () => <AccessFilterSelector />,
        nameAttribute: 'fullName',
      },
    ],
    identifier: 'ownerIds',
  })

export default ownerFilter
